// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bundle-transfer-warning-dialog {
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  width: 100%;
  max-width: 500px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  overflow: hidden;
}
:host-context(body.theme-dark) .bundle-transfer-warning-dialog {
  background: #1a1a1a;
  color: #ffffff;
}
@media (prefers-contrast: high) {
  .bundle-transfer-warning-dialog {
    border: 2px solid #000000;
  }
}
@media (prefers-reduced-motion: reduce) {
  .bundle-transfer-warning-dialog * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
.bundle-transfer-warning-dialog .dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%);
  color: white;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
.bundle-transfer-warning-dialog .dialog-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
}
.bundle-transfer-warning-dialog .dialog-header .header-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
}
.bundle-transfer-warning-dialog .dialog-header .close-button {
  color: white;
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid transparent;
  padding: 0;
  margin: 0;
}
.bundle-transfer-warning-dialog .dialog-header .close-button:hover {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.4);
  transform: scale(1.05);
}
.bundle-transfer-warning-dialog .dialog-header .close-button:active {
  background: rgba(255, 255, 255, 0.4);
  transform: scale(0.95);
}
.bundle-transfer-warning-dialog .dialog-header .close-button:focus {
  outline: none;
}
.bundle-transfer-warning-dialog .dialog-header .close-button:focus-visible {
  outline: none;
}
.bundle-transfer-warning-dialog .dialog-header .close-button mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}
.bundle-transfer-warning-dialog .dialog-content {
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 24px;
}
.bundle-transfer-warning-dialog .dialog-content .warning-content {
  text-align: center;
}
.bundle-transfer-warning-dialog .dialog-content .warning-content .warning-icon-large {
  margin-bottom: 20px;
}
.bundle-transfer-warning-dialog .dialog-content .warning-content .warning-icon-large mat-icon {
  font-size: 64px;
  width: 64px;
  height: 64px;
  color: #ff6b6b;
  opacity: 0.8;
}
.bundle-transfer-warning-dialog .dialog-content .warning-content h3 {
  margin: 0 0 16px 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}
.bundle-transfer-warning-dialog .dialog-content .warning-content p {
  margin: 0 0 20px 0;
  font-size: 14px;
  line-height: 1.5;
  color: #666;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
}
.bundle-transfer-warning-dialog .dialog-content .warning-content .info-box {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 16px;
  text-align: left;
}
.bundle-transfer-warning-dialog .dialog-content .warning-content .info-box .info-icon {
  color: #667eea;
  font-size: 20px;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  margin-top: 2px;
}
.bundle-transfer-warning-dialog .dialog-content .warning-content .info-box span {
  font-size: 13px;
  line-height: 1.4;
  color: #495057;
}
.bundle-transfer-warning-dialog .dialog-actions {
  display: flex;
  justify-content: center;
  padding: 20px 24px;
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
  position: sticky;
  bottom: 0;
  min-height: 60px;
}
.bundle-transfer-warning-dialog .dialog-actions .close-action-btn {
  background: #6c757d;
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
  padding: 12px 24px;
  height: 40px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.bundle-transfer-warning-dialog .dialog-actions .close-action-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.bundle-transfer-warning-dialog .dialog-actions .close-action-btn:hover {
  background: #5a6268;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);
}
.bundle-transfer-warning-dialog .dialog-actions .close-action-btn:active {
  transform: translateY(0);
}

@media (max-width: 768px) {
  .bundle-transfer-warning-dialog {
    max-height: 90vh;
    margin: 16px;
    border-radius: 8px;
  }
  .bundle-transfer-warning-dialog .dialog-header {
    padding: 16px 20px;
  }
  .bundle-transfer-warning-dialog .dialog-header h2 {
    font-size: 18px;
  }
  .bundle-transfer-warning-dialog .dialog-content {
    padding: 20px;
  }
  .bundle-transfer-warning-dialog .dialog-content .warning-content .warning-icon-large {
    margin-bottom: 16px;
  }
  .bundle-transfer-warning-dialog .dialog-content .warning-content .warning-icon-large mat-icon {
    font-size: 56px;
    width: 56px;
    height: 56px;
  }
  .bundle-transfer-warning-dialog .dialog-content .warning-content h3 {
    font-size: 16px;
    margin-bottom: 12px;
  }
  .bundle-transfer-warning-dialog .dialog-content .warning-content p {
    font-size: 13px;
    margin-bottom: 16px;
  }
  .bundle-transfer-warning-dialog .dialog-content .warning-content .info-box {
    padding: 14px;
    gap: 10px;
  }
  .bundle-transfer-warning-dialog .dialog-content .warning-content .info-box .info-icon {
    font-size: 18px;
    width: 18px;
    height: 18px;
  }
  .bundle-transfer-warning-dialog .dialog-content .warning-content .info-box span {
    font-size: 12px;
  }
  .bundle-transfer-warning-dialog .dialog-actions {
    padding: 16px 20px;
    min-height: 56px;
  }
  .bundle-transfer-warning-dialog .dialog-actions .close-action-btn {
    height: 44px;
    font-size: 13px;
    padding: 10px 20px;
  }
  .bundle-transfer-warning-dialog .dialog-actions .close-action-btn mat-icon {
    font-size: 16px;
    width: 16px;
    height: 16px;
  }
}
@media (max-width: 480px) {
  .bundle-transfer-warning-dialog {
    margin: 8px;
    border-radius: 6px;
  }
  .bundle-transfer-warning-dialog .dialog-header {
    padding: 12px 16px;
  }
  .bundle-transfer-warning-dialog .dialog-header h2 {
    font-size: 16px;
  }
  .bundle-transfer-warning-dialog .dialog-header .close-button {
    width: 36px;
    height: 36px;
    min-width: 36px;
    min-height: 36px;
  }
  .bundle-transfer-warning-dialog .dialog-header .close-button mat-icon {
    font-size: 18px;
    width: 18px;
    height: 18px;
  }
  .bundle-transfer-warning-dialog .dialog-content {
    padding: 16px;
  }
  .bundle-transfer-warning-dialog .dialog-content .warning-content .warning-icon-large {
    margin-bottom: 12px;
  }
  .bundle-transfer-warning-dialog .dialog-content .warning-content .warning-icon-large mat-icon {
    font-size: 48px;
    width: 48px;
    height: 48px;
  }
  .bundle-transfer-warning-dialog .dialog-content .warning-content h3 {
    font-size: 15px;
    margin-bottom: 10px;
  }
  .bundle-transfer-warning-dialog .dialog-content .warning-content p {
    font-size: 12px;
    margin-bottom: 14px;
  }
  .bundle-transfer-warning-dialog .dialog-content .warning-content .info-box {
    padding: 12px;
    gap: 8px;
  }
  .bundle-transfer-warning-dialog .dialog-content .warning-content .info-box .info-icon {
    font-size: 16px;
    width: 16px;
    height: 16px;
  }
  .bundle-transfer-warning-dialog .dialog-content .warning-content .info-box span {
    font-size: 11px;
  }
  .bundle-transfer-warning-dialog .dialog-actions {
    padding: 12px 16px;
    min-height: 52px;
  }
  .bundle-transfer-warning-dialog .dialog-actions .close-action-btn {
    height: 42px;
    font-size: 12px;
    padding: 8px 16px;
    gap: 6px;
  }
  .bundle-transfer-warning-dialog .dialog-actions .close-action-btn mat-icon {
    font-size: 14px;
    width: 14px;
    height: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/bundle-transfer-warning-dialog/bundle-transfer-warning-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,0CAAA;EACA,gBAAA;AACF;AAEE;EACE,mBAAA;EACA,cAAA;AAAJ;AAIE;EAlBF;IAmBI,yBAAA;EADF;AACF;AAIE;EACE;IACE,qCAAA;IACA,uCAAA;IACA,sCAAA;EAFJ;AACF;AAKE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,6DAAA;EACA,YAAA;EACA,iDAAA;AAHJ;AAKI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAHN;AAMI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAJN;AAOI;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,oCAAA;EACA,6BAAA;EACA,UAAA;EACA,SAAA;AALN;AAOM;EACE,oCAAA;EACA,sCAAA;EACA,sBAAA;AALR;AAQM;EACE,oCAAA;EACA,sBAAA;AANR;AASM;EACE,aAAA;AAPR;AAUM;EACE,aAAA;AARR;AAWM;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AATR;AAcE;EACE,cAAA;EACA,gBAAA;EACA,aAAA;AAZJ;AAcI;EACE,kBAAA;AAZN;AAcM;EACE,mBAAA;AAZR;AAcQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;AAZV;AAgBM;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAdR;AAiBM;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAfR;AAkBM;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;AAhBR;AAkBQ;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AAhBV;AAmBQ;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAjBV;AAuBE;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;AArBJ;AAuBI;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AArBN;AAuBM;EACE,eAAA;EACA,WAAA;EACA,YAAA;AArBR;AAwBM;EACE,mBAAA;EACA,2BAAA;EACA,+CAAA;AAtBR;AAyBM;EACE,wBAAA;AAvBR;;AA8BA;EACE;IACE,gBAAA;IACA,YAAA;IACA,kBAAA;EA3BF;EA6BE;IACE,kBAAA;EA3BJ;EA6BI;IACE,eAAA;EA3BN;EA+BE;IACE,aAAA;EA7BJ;EAgCM;IACE,mBAAA;EA9BR;EAgCQ;IACE,eAAA;IACA,WAAA;IACA,YAAA;EA9BV;EAkCM;IACE,eAAA;IACA,mBAAA;EAhCR;EAmCM;IACE,eAAA;IACA,mBAAA;EAjCR;EAoCM;IACE,aAAA;IACA,SAAA;EAlCR;EAoCQ;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAlCV;EAqCQ;IACE,eAAA;EAnCV;EAyCE;IACE,kBAAA;IACA,gBAAA;EAvCJ;EAyCI;IACE,YAAA;IACA,eAAA;IACA,kBAAA;EAvCN;EAyCM;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAvCR;AACF;AA6CA;EACE;IACE,WAAA;IACA,kBAAA;EA3CF;EA6CE;IACE,kBAAA;EA3CJ;EA6CI;IACE,eAAA;EA3CN;EA8CI;IACE,WAAA;IACA,YAAA;IACA,eAAA;IACA,gBAAA;EA5CN;EA8CM;IACE,eAAA;IACA,WAAA;IACA,YAAA;EA5CR;EAiDE;IACE,aAAA;EA/CJ;EAkDM;IACE,mBAAA;EAhDR;EAkDQ;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAhDV;EAoDM;IACE,eAAA;IACA,mBAAA;EAlDR;EAqDM;IACE,eAAA;IACA,mBAAA;EAnDR;EAsDM;IACE,aAAA;IACA,QAAA;EApDR;EAsDQ;IACE,eAAA;IACA,WAAA;IACA,YAAA;EApDV;EAuDQ;IACE,eAAA;EArDV;EA2DE;IACE,kBAAA;IACA,gBAAA;EAzDJ;EA2DI;IACE,YAAA;IACA,eAAA;IACA,iBAAA;IACA,QAAA;EAzDN;EA2DM;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAzDR;AACF","sourcesContent":[".bundle-transfer-warning-dialog {\n  display: flex;\n  flex-direction: column;\n  max-height: 80vh;\n  width: 100%;\n  max-width: 500px;\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);\n  overflow: hidden;\n\n  // Dark mode support\n  :host-context(body.theme-dark) & {\n    background: #1a1a1a;\n    color: #ffffff;\n  }\n\n  // High contrast support\n  @media (prefers-contrast: high) {\n    border: 2px solid #000000;\n  }\n\n  // Reduced motion support\n  @media (prefers-reduced-motion: reduce) {\n    * {\n      animation-duration: 0.01ms !important;\n      animation-iteration-count: 1 !important;\n      transition-duration: 0.01ms !important;\n    }\n  }\n\n  .dialog-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 20px 24px;\n    background: linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%);\n    color: white;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n\n    h2 {\n      margin: 0;\n      font-size: 20px;\n      font-weight: 600;\n      display: flex;\n      align-items: center;\n      gap: 8px;\n    }\n\n    .header-icon {\n      font-size: 24px;\n      width: 24px;\n      height: 24px;\n    }\n\n    .close-button {\n      color: white;\n      width: 40px;\n      height: 40px;\n      min-width: 40px;\n      min-height: 40px;\n      border-radius: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      transition: all 0.2s ease;\n      background: rgba(255, 255, 255, 0.2);\n      border: 1px solid transparent;\n      padding: 0;\n      margin: 0;\n\n      &:hover {\n        background: rgba(255, 255, 255, 0.3);\n        border-color: rgba(255, 255, 255, 0.4);\n        transform: scale(1.05);\n      }\n\n      &:active {\n        background: rgba(255, 255, 255, 0.4);\n        transform: scale(0.95);\n      }\n\n      &:focus {\n        outline: none;\n      }\n\n      &:focus-visible {\n        outline: none;\n      }\n\n      mat-icon {\n        font-size: 20px;\n        width: 20px;\n        height: 20px;\n        line-height: 20px;\n        color: white;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n    }\n  }\n\n  .dialog-content {\n    flex: 1 1 auto;\n    overflow-y: auto;\n    padding: 24px;\n\n    .warning-content {\n      text-align: center;\n\n      .warning-icon-large {\n        margin-bottom: 20px;\n\n        mat-icon {\n          font-size: 64px;\n          width: 64px;\n          height: 64px;\n          color: #ff6b6b;\n          opacity: 0.8;\n        }\n      }\n\n      h3 {\n        margin: 0 0 16px 0;\n        font-size: 18px;\n        font-weight: 600;\n        color: #333;\n      }\n\n      p {\n        margin: 0 0 20px 0;\n        font-size: 14px;\n        line-height: 1.5;\n        color: #666;\n        max-width: 400px;\n        margin-left: auto;\n        margin-right: auto;\n      }\n\n      .info-box {\n        display: flex;\n        align-items: flex-start;\n        gap: 12px;\n        background: #f8f9fa;\n        border: 1px solid #e9ecef;\n        border-radius: 8px;\n        padding: 16px;\n        text-align: left;\n\n        .info-icon {\n          color: #667eea;\n          font-size: 20px;\n          width: 20px;\n          height: 20px;\n          flex-shrink: 0;\n          margin-top: 2px;\n        }\n\n        span {\n          font-size: 13px;\n          line-height: 1.4;\n          color: #495057;\n        }\n      }\n    }\n  }\n\n  .dialog-actions {\n    display: flex;\n    justify-content: center;\n    padding: 20px 24px;\n    background: #f8f9fa;\n    border-top: 1px solid #e9ecef;\n    position: sticky;\n    bottom: 0;\n    min-height: 60px;\n\n    .close-action-btn {\n      background: #6c757d;\n      color: white;\n      border: none;\n      border-radius: 8px;\n      font-weight: 500;\n      font-size: 14px;\n      padding: 12px 24px;\n      height: 40px;\n      transition: all 0.2s ease;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 8px;\n\n      mat-icon {\n        font-size: 18px;\n        width: 18px;\n        height: 18px;\n      }\n\n      &:hover {\n        background: #5a6268;\n        transform: translateY(-1px);\n        box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);\n      }\n\n      &:active {\n        transform: translateY(0);\n      }\n    }\n  }\n}\n\n// Mobile Responsiveness\n@media (max-width: 768px) {\n  .bundle-transfer-warning-dialog {\n    max-height: 90vh;\n    margin: 16px;\n    border-radius: 8px;\n\n    .dialog-header {\n      padding: 16px 20px;\n\n      h2 {\n        font-size: 18px;\n      }\n    }\n\n    .dialog-content {\n      padding: 20px;\n\n      .warning-content {\n        .warning-icon-large {\n          margin-bottom: 16px;\n\n          mat-icon {\n            font-size: 56px;\n            width: 56px;\n            height: 56px;\n          }\n        }\n\n        h3 {\n          font-size: 16px;\n          margin-bottom: 12px;\n        }\n\n        p {\n          font-size: 13px;\n          margin-bottom: 16px;\n        }\n\n        .info-box {\n          padding: 14px;\n          gap: 10px;\n\n          .info-icon {\n            font-size: 18px;\n            width: 18px;\n            height: 18px;\n          }\n\n          span {\n            font-size: 12px;\n          }\n        }\n      }\n    }\n\n    .dialog-actions {\n      padding: 16px 20px;\n      min-height: 56px;\n\n      .close-action-btn {\n        height: 44px;\n        font-size: 13px;\n        padding: 10px 20px;\n\n        mat-icon {\n          font-size: 16px;\n          width: 16px;\n          height: 16px;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .bundle-transfer-warning-dialog {\n    margin: 8px;\n    border-radius: 6px;\n\n    .dialog-header {\n      padding: 12px 16px;\n\n      h2 {\n        font-size: 16px;\n      }\n\n      .close-button {\n        width: 36px;\n        height: 36px;\n        min-width: 36px;\n        min-height: 36px;\n\n        mat-icon {\n          font-size: 18px;\n          width: 18px;\n          height: 18px;\n        }\n      }\n    }\n\n    .dialog-content {\n      padding: 16px;\n\n      .warning-content {\n        .warning-icon-large {\n          margin-bottom: 12px;\n\n          mat-icon {\n            font-size: 48px;\n            width: 48px;\n            height: 48px;\n          }\n        }\n\n        h3 {\n          font-size: 15px;\n          margin-bottom: 10px;\n        }\n\n        p {\n          font-size: 12px;\n          margin-bottom: 14px;\n        }\n\n        .info-box {\n          padding: 12px;\n          gap: 8px;\n\n          .info-icon {\n            font-size: 16px;\n            width: 16px;\n            height: 16px;\n          }\n\n          span {\n            font-size: 11px;\n          }\n        }\n      }\n    }\n\n    .dialog-actions {\n      padding: 12px 16px;\n      min-height: 52px;\n\n      .close-action-btn {\n        height: 42px;\n        font-size: 12px;\n        padding: 8px 16px;\n        gap: 6px;\n\n        mat-icon {\n          font-size: 14px;\n          width: 14px;\n          height: 14px;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
